// converts string values 'true' and 'false' to true and false boolean values respectively.
// If string is niether 'true' or 'false', it will return undefinied
export const stringToBool = (stringVal: string): boolean | undefined => {
  try {
    return JSON.parse(stringVal);
  } catch (e) {
    return undefined;
  }
};
